window.initHowItWorks ?? (() => {
  window.initHowItWorks = (section_id) => {

    const howItWorksSection = document.querySelector(
      `section#shopify-section-${section_id} .careline-20-how-it-works`
    );

    if (!howItWorksSection) return;

    const steps = howItWorksSection.querySelectorAll('.how-it-works-panel-content-inner');
    const image = howItWorksSection.querySelector('.how-it-works-panel-image img');
    const tag = howItWorksSection.querySelector('#how-it-works-tag-dynamic');

    let currentStep = null;
    let ticking = false;

    const isInTriggerZone = (el) => {
      const rect = el.getBoundingClientRect();
      const elementMiddle = rect.top + rect.height / 2;

      // 👇 tweak this (0.5 = center, 0.6 = slightly lower = nicer UX)
      const triggerPoint = window.innerHeight * 0.6;

      const threshold = 150; // px tolerance

      return Math.abs(elementMiddle - triggerPoint) < threshold;
    };

    const updateStep = (step) => {
      const newImg = step.dataset.image;
      const newTag = step.querySelector('.how-it-works-tag');

      // prevent unnecessary updates
      if (currentStep === step) return;
      currentStep = step;

      // IMAGE
      if (newImg && newImg !== image.src.replace('https:', '')) {
        image.style.opacity = 0;

        //steps.forEach((s) => s.classList.remove('active'));

        setTimeout(() => {
          image.src = newImg;
          image.style.opacity = 1;
          //step.classList.add('active');
        }, 400);
      }

      // TAG
      if (tag) {
        tag.style.opacity = 0;

        setTimeout(() => {
          if (newTag) {
            tag.innerHTML = newTag.innerHTML;
            tag.style.opacity = 1;
          } else {
            tag.innerHTML = '';
          }
        }, 400);
      }
    };

    const handleScroll = () => {
      steps.forEach((step) => {
        if (isInTriggerZone(step)) {
          updateStep(step);
        }
      });
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll);

    // trigger on load (important)
    handleScroll();
  };
})();